import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/**
 * FeaturesDialog — opens from the Home hero "ici" link. Presents the
 * full feature walkthrough (search, publish, join, chat, premium…) in
 * a full-story-visual style card (Discover gradient + white text +
 * emoji bullets) so it doubles as a shareable brand card.
 */
export default function FeaturesDialog({ open, onOpenChange }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                data-testid="features-dialog"
                className="max-w-2xl bg-discover-gradient text-white border-none p-0 overflow-hidden">
                <div className="relative">
                    <div className="absolute -right-16 -top-16 w-72 h-72 rounded-full bg-white/10 blur-3xl pointer-events-none" />
                    <div className="absolute -left-20 -bottom-24 w-80 h-80 rounded-full bg-white/10 blur-3xl pointer-events-none" />
                    <div className="relative px-6 md:px-10 py-8 md:py-10 space-y-4 max-h-[80vh] overflow-y-auto">
                        <DialogHeader className="text-left">
                            <DialogTitle className="text-2xl md:text-3xl font-black text-white leading-tight">
                                Découvrez toutes les fonctionnalités de Discoveur
                            </DialogTitle>
                        </DialogHeader>

                        <ul className="space-y-3 text-sm md:text-base leading-relaxed">
                            <li className="flex gap-2">
                                <span aria-hidden="true">🔎</span>
                                <span>
                                    <strong>Recherchez</strong> ce qui vous intéresse en
                                    quelques secondes : par date, commune, territoire ou
                                    mot-clé.
                                </span>
                            </li>
                            <li className="flex gap-2">
                                <span aria-hidden="true">⭐</span>
                                <span>
                                    <strong>Personnalisez</strong> votre expérience
                                    (précisez votre profil) et recevez des suggestions
                                    adaptées à vos envies.
                                </span>
                            </li>
                            <li className="flex gap-2">
                                <span aria-hidden="true">📢</span>
                                <span>
                                    <strong>Publiez et partagez</strong> vos propres
                                    événements afin de les faire découvrir à toute la
                                    communauté.
                                </span>
                            </li>
                            <li className="flex gap-2">
                                <span aria-hidden="true">✅</span>
                                <span>
                                    Vous avez vu un évènement qui vous plaît ? Vous hésitez
                                    à participer ? <strong>Suivez l'événement</strong> pour
                                    le retrouver facilement. Prêt à y aller ? Cliquez sur
                                    « <strong>Rejoindre</strong> » pour l'ajouter à votre
                                    agenda et recevoir un rappel automatique.
                                </span>
                            </li>
                            <li className="flex gap-2">
                                <span aria-hidden="true">💬</span>
                                <span>
                                    <strong>Échangez</strong> si vous le souhaitez avec les
                                    autres participants grâce à l'onglet discussion pour
                                    organiser du covoiturage, partager des informations ou
                                    faire connaissance avant et après l'événement.
                                </span>
                            </li>
                            <li className="flex gap-2">
                                <span aria-hidden="true">🎨</span>
                                <span>
                                    Avec l'offre <strong>Premium</strong>, créez facilement
                                    vos flyers promotionnels et publiez-les directement sur
                                    la plateforme pour toucher un public plus large.
                                </span>
                            </li>
                        </ul>

                        <div className="pt-4 border-t border-white/25 space-y-2 text-sm md:text-base">
                            <p>
                                <span aria-hidden="true">✨ </span>
                                Ensemble, faisons rayonner les événements, la culture, les
                                loisirs, le tourisme et les talents des Outre-mer.
                            </p>
                            <p className="font-black text-base md:text-lg">
                                Discoveur : découvrez, partagez, participez !
                            </p>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
